/*
    Copyright © DokiApp, 2026
*/

import React, { useEffect, useState } from 'react'
import { navigate } from '@reach/router'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Heading } from '../../components/Text'
import { Step } from '../../components'
import { useStoreActions, useStoreState } from '../../store/store.hooks'
import { MYMEDIO_URLS } from '../../constants'
import { get } from '../../services/request'

const useStyles = makeStyles((theme) => ({
  dashBoardContainer: {
    padding: '60px 30px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '15px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: '20px',
    },
  },
  gridRow: {
    marginTop: theme.spacing(1),
  },
  intro: {
    fontSize: '1.25rem',
    color: '#1E2864',
    margin: '1rem auto 0',
    maxWidth: '900px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1rem',
    },
  },
}))

const MentalWellbeingDaysServices = () => {
  const classes = useStyles()
  const { t } = useTranslation('services')
  const { fetchSettings } = useStoreActions((actions) => actions.settings)
  const { settingsByKey } = useStoreState((state) => state.settings)

  useEffect(() => {
    fetchSettings()
  }, [fetchSettings])

  const [hasCompletedSurvey, setHasCompletedSurvey] = useState(false)

  useEffect(() => {
    const fetchSurveys = async () => {
      try {
        const { surveys } = await get('/surveys/4ig-mental-wellbeing-days')
        setHasCompletedSurvey(surveys.some((s) => s.completed))
      } catch (err) {
        console.error('Failed to fetch mental wellbeing days surveys', err)
      }
    }

    fetchSurveys()
  }, [])

  const navigateInNewTab = (url) => {
    if (!url) return

    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

  const navigateToSurveys = () => {
    navigate('/patient/surveys/4ig')
  }

  const navigateToBooking = () => {
    navigateInNewTab(settingsByKey[MYMEDIO_URLS.MENTAL_WELLBEING_DAYS_BOOKING])
  }

  return (
    <Grid item xs={12} className={classes.dashBoardContainer}>
      <Heading>{t('mentalWellbeingDaysHeading')}</Heading>
      <Typography className={classes.intro}>
        {t('mentalWellbeingDaysIntro')}
      </Typography>
      <Grid container spacing={2} className={classes.gridRow}>
        <Grid item xs={12}>
          <Step
            theme="mentalWellbeingDiagnostics"
            title={t('mentalWellbeingDaysSurveysTitle')}
            description={t('mentalWellbeingDaysSurveysDetails')}
            buttonText={t('mentalWellbeingDaysSurveysButtonText')}
            onNavigate={navigateToSurveys}
          />
        </Grid>
        <Grid item xs={12}>
          <Step
            theme="md"
            title={t('mentalWellbeingDaysBookingTitle')}
            description={t('mentalWellbeingDaysBookingDetails')}
            buttonText={t('mentalWellbeingDaysBookingButtonText')}
            onNavigate={navigateToBooking}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

MentalWellbeingDaysServices.displayName = 'MentalWellbeingDaysServices'

export default MentalWellbeingDaysServices
export { MentalWellbeingDaysServices }
